import fetchRequest from '../util/fetch'
import errUtil from '../util/error'
import q from './query'

const query = `mutation ShiftCreateStandByActivityMutation (
  $workspace: ID!,
  $shift: ID!,
  $activity: StandByActivityInput!
) {
  shiftCreateStandByActivity (
    workspace: $workspace
    shift: $shift
    activity: $activity
  ) ${q.SHIFT_BASIC}
}`

async function requestShiftCreateStandByActivity (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errUtil.apiError('shift-create-standby-activity', errors)
  }
  return data.shiftCreateStandByActivity
}

export default requestShiftCreateStandByActivity
